import spiderSeatUrl from "../../assets/icons/spider-seat.svg"

type SpiderManSeatIconProps = {
    /** Выбранное — белая обводка; занятое — та же маска без обводки */
    variant: "selected" | "occupied"
    className?: string
}

export function SpiderManSeatIcon({ variant, className }: SpiderManSeatIconProps) {
    const selected = variant === "selected"

    return (
        <span
            className={className}
            aria-hidden
            style={{
                display: "inline-flex",
                boxSizing: "border-box",
                borderRadius: "22%",
                overflow: "hidden",
                boxShadow: selected ? "0 0 0 2.5px #fff" : undefined,
            }}>
            <img src={spiderSeatUrl} alt="" className="block h-full w-full" draggable={false} />
        </span>
    )
}
